// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Rectangle } from '@shared/commons/Geometry';
import React from 'react';
export class HoverableContextMenuComponent extends React.Component {
    constructor() {
        super(...arguments);
        this.onPointerMove = (event) => {
            var _a;
            const elBoundRect = this.props.refToElement.current.getBoundingClientRect();
            if (elBoundRect.contains(event.clientX, event.clientY) ||
                isNullOrUndefined((_a = this.props.contextMenuRef) === null || _a === void 0 ? void 0 : _a.current)) {
                return;
            }
            const menuElement = this.props.contextMenuRef.current;
            const menuBoundRect = menuElement.getBoundingClientRect();
            if (menuBoundRect.contains(event.clientX, event.clientY)) {
                return;
            }
            const eps = 2;
            const betweenRect = new Rectangle(elBoundRect.left, elBoundRect.bottom - eps, elBoundRect.width, menuBoundRect.top - elBoundRect.bottom + eps * 2);
            if (betweenRect.Contains(event.clientX, event.clientY)) {
                return;
            }
            const activeInput = menuElement.querySelector('div.js-input-container[focused]');
            if (!isNullOrUndefined(activeInput)) {
                return;
            }
            this.hideContextMenu();
        };
        this.hideContextMenu = () => {
            hideContextMenu();
        };
        this.unsubscribeDocumentEvents = () => {
            document.removeEventListener('pointermove', this.onPointerMove);
            document.removeEventListener('pointerleave', this.hideContextMenu);
        };
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.contextMenuRef !== this.props.contextMenuRef) {
            if (!isNullOrUndefined(this.props.contextMenuRef)) {
                document.addEventListener('pointermove', this.onPointerMove);
                document.addEventListener('pointerleave', this.hideContextMenu);
            }
            else {
                this.unsubscribeDocumentEvents();
            }
        }
    }
    componentWillUnmount() {
        if (!isNullOrUndefined(this.props.contextMenuRef)) {
            this.unsubscribeDocumentEvents();
        }
    }
    render() {
        const { children, className } = this.props;
        return (React.createElement("div", { ref: this.props.refToElement, className: className, onPointerEnter: (event) => this.props.onPointerEnter(event), onPointerLeave: (event) => this.props.onPointerLeave(event) }, children));
    }
}
